import { z } from "zod";
import { idempotencyKey, positiveDecimalString, strictObject } from "./requests.js";
import { bigintIdString } from "./field-shapes.js";
const reference = z.string().trim().min(1).max(500);
export const createVendorCreditAccountBody = strictObject({ label: z.string().trim().min(1).max(200),
  vendorIds: z.array(z.string().uuid()).min(1).max(100), idempotencyKey });
export const issueVendorCreditBody = strictObject({ accountId: z.string().uuid(), amount: positiveDecimalString,
  reference, recoveryCostEntryId: bigintIdString("expected a recovery cost id").nullish(), idempotencyKey });
export const applyVendorCreditBody = strictObject({ creditId: z.string().uuid(), vendorInvoiceId: z.string().uuid(),
  amount: positiveDecimalString, reference, idempotencyKey });
export const reverseVendorCreditBody = strictObject({ reason: reference, idempotencyKey });
export const vendorCreditsQuery = strictObject({ workOrderId: z.string().uuid().optional(), purchaseOrderId: z.string().uuid().optional() });
export interface VendorCreditView {
  accounts: Array<{ accountId: string; label: string; currency: string; available: string; memberNames: string[] }>;
  credits: Array<{ creditId: string; accountId: string; reference: string; issued: string; available: string; recoveryCostEntryId: string | null }>;
  entries: Array<{ entryId: string; accountId: string; kind: "issue" | "apply" | "reversal"; amount: string;
    reference: string; invoiceNumber: string | null; recordedBy: string; recordedAt: string; reversed: boolean }>;
  invoices: Array<{ vendorInvoiceId: string; invoiceNumber: string; currency: string; outstanding: string }>;
  recoveries: Array<{ costEntryId: string; amount: string; workOrderNumber: string; kind: string }>;
  canUse: boolean; canConfigure: boolean;
}
